interface ChatRequestInput {
  /** The notebook's one conversation. */
  notebookId: string;
  /** The checked, indexed sources retrieval is narrowed to (the API accepts 1..25). */
  documentIds: string[];
  query: string;
  quoteText?: string | null;
  chatTier: string;
  documentTitle?: string;
  organizationId?: string | null;
}

export interface ChatRequestBody {
  notebookId: string;
  documentIds: string[];
  query: string;
  quoteText?: string;
  chatTier: string;
  documentTitle?: string;
  organizationId?: string;
}

/** The `POST /api/chat` body. There is deliberately no `documentId`: the notebook is the conversation key. */
export function buildChatRequestBody({
  notebookId,
  documentIds,
  query,
  quoteText,
  chatTier,
  documentTitle,
  organizationId,
}: ChatRequestInput): ChatRequestBody {
  return {
    notebookId: notebookId.trim(),
    documentIds: [...documentIds],
    query,
    quoteText: quoteText || undefined,
    chatTier,
    documentTitle: documentTitle || undefined,
    organizationId: organizationId || undefined,
  };
}
